module.exports = __webpack_public_path__ + "fbStatic/fonts/element-icons.535877f5.woff";